import { TimeInForceType } from '@/compiled_proto/com/celertech/positionmanager/api/enums/TimeInForceTypeProto';
import InputController from '@/components/inputs/InputController';
import Select from '@/components/inputs/Select';
import { xplorSpotLiteTitle, xplorSpotTitle } from '@/helpers/environmentHelper';
import useLanguage from '@/utils/hooks/useLanguage';
import { showLayoutSwitch } from '@/utils/route';
import { Tab } from '@headlessui/react';

export const tradingLayoutOptions = [
    // { label: 'WolfBTC Spot (Advanced)', value: 'xplorspot' },
    // { label: 'WolfBTC Lite (Simplified)', value: 'xplorspotlite' }
    { label: `${xplorSpotTitle} (Advanced)`, value: 'xplorspot' },
    { label: `${xplorSpotLiteTitle} (Simplified)`, value: 'xplorspotlite' }
    // { label: 'XplorTrader', value: 'xplortrader' }
];

export const twoClickTradingOptions = [
    { label: 'Enabled', value: true },
    { label: 'Disabled', value: false }
];

export const shortSellPreventionOptions = [
    { label: 'Disabled', value: false },
    { label: 'Enabled', value: true }
];

export const defaultMarketOrderDurationOptions: { label: keyof typeof TimeInForceType; value: TimeInForceType }[] = [
    { label: 'IOC', value: TimeInForceType.IOC },
    { label: 'FOK', value: TimeInForceType.FOK }
];

export const defaultLimitOrderDurationOptions: { label: keyof typeof TimeInForceType; value: TimeInForceType }[] = [
    { label: 'DAY', value: TimeInForceType.DAY },
    { label: 'GTC', value: TimeInForceType.GTC },
    { label: 'IOC', value: TimeInForceType.IOC },
    { label: 'FOK', value: TimeInForceType.FOK }
];

export const defaultStopOrderDurationOptions: { label: keyof typeof TimeInForceType; value: TimeInForceType }[] = [
    { label: 'DAY', value: TimeInForceType.DAY },
    { label: 'GTC', value: TimeInForceType.GTC }
];

const TradingTab = () => {
    const lang = useLanguage();
    return (
        <Tab.Panel className="p-2 py-3 sm:p-4 h-auto lg:h-[400px]">
            <div className="space-y-4">
                {showLayoutSwitch && !location.pathname.includes('/trader') && (
                    <div className="space-y-3 sm:space-y-2">
                        <InputController
                            name="trading.tradingLayout"
                            label={lang.settings.tradingLayoutSettings}
                            required>
                            <Select options={tradingLayoutOptions} />
                        </InputController>
                        <div className="space-y-3 sm:space-y-1">
                            {lang.settings.tradingLayoutSettingsDescription.split('\n').map((line, index) => (
                                <div key={index} className="text-xs text-brand-neutral-400">
                                    {line}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div className="space-y-3 sm:space-y-2">
                    <InputController
                        name="trading.twoClickTrading"
                        label={lang.settings.twoClickTradingSettings}
                        required>
                        <Select options={twoClickTradingOptions} />
                    </InputController>
                    <div className="space-y-3 sm:space-y-1">
                        {lang.settings.twoClickTradingSettingsDescription.split('\n').map((line, index) => (
                            <div key={index} className="text-xs text-brand-neutral-400">
                                {line}
                            </div>
                        ))}
                    </div>
                </div>
                {location.pathname.includes('/lite') && (
                    <div className="space-y-3 sm:space-y-2">
                        <InputController
                            name="trading.shortSellPrevention"
                            label={lang.settings.shortSellPreventionSettings}
                            required>
                            <Select options={shortSellPreventionOptions} />
                        </InputController>
                        <div className="space-y-3 sm:space-y-1">
                            {lang.settings.shortSellPreventionSettingsDescription.split('\n').map((line, index) => (
                                <div key={index} className="text-xs text-brand-neutral-400">
                                    {line}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div className="space-y-3 sm:space-y-2">
                    <InputController
                        name="trading.defaultMarketOrderDuration"
                        label={lang.settings.defaultMarketOrderDurationSettings}
                        required>
                        <Select options={defaultMarketOrderDurationOptions} />
                    </InputController>
                    <div className="space-y-3 sm:space-y-1">
                        {lang.settings.defaultMarketOrderDurationSettingsDescription.split('\n').map((line, index) => (
                            <div key={index} className="text-xs text-brand-neutral-400">
                                {line}
                            </div>
                        ))}
                    </div>
                    <InputController
                        name="trading.defaultLimitOrderDuration"
                        label={lang.settings.defaultLimitOrderDurationSettings}
                        required>
                        <Select options={defaultLimitOrderDurationOptions} />
                    </InputController>
                    <div className="space-y-3 sm:space-y-1">
                        {lang.settings.defaultLimitOrderDurationSettingsDescription.split('\n').map((line, index) => (
                            <div key={index} className="text-xs text-brand-neutral-400">
                                {line}
                            </div>
                        ))}
                    </div>
                    <InputController
                        name="trading.defaultStopOrderDuration"
                        label={lang.settings.defaultStopOrderDurationSettings}
                        required>
                        <Select options={defaultStopOrderDurationOptions} />
                    </InputController>
                    <div className="space-y-3 sm:space-y-1 pb-5">
                        {lang.settings.defaultStopOrderDurationSettingsDescription.split('\n').map((line, index) => (
                            <div key={index} className="text-xs text-brand-neutral-400">
                                {line}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Tab.Panel>
    );
};
export default TradingTab;
